<template>
    <main-content v-if="$can('read', 'ipg-gateway')">
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#collective-list" role="tab" aria-selected="false">
                                {{ $t('label.collective_gateways_list') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#collective-settings" role="tab" aria-selected="false">
                                {{ $t('label.general_collective_settings') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{ name: 'active_gateways' }" class="nav-link">
                                {{ $t('label.collective_list') }}
                            </router-link>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
                <kt-panel-header-actions :style="headerAction">
                    <router-link :to="{ name: 'collective_create' }" class="btn btn-success">
                        {{ $t('label.add_collective_gateway') + " " }}
                    </router-link>
                </kt-panel-header-actions>
            </kt-panel-header>
            <kt-panel-body>
                <div class="tab-content">
                    <div class="tab-pane active" id="collective-list">
                        <collective-gateways></collective-gateways>
                    </div>
                    <div class="tab-pane" id="collective-settings">
                        <general-collective-settings></general-collective-settings>
                    </div>
                </div>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import generalCollectiveSettings from './components/general-collective-settings'
import collectiveGateways from './components/collective-gateways'

export default {
    components: {
        'main-content': mainContent,
        'general-collective-settings': generalCollectiveSettings,
        'collective-gateways': collectiveGateways,
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
        }
    },
}
</script>

<style>

</style>